import React, { useState } from "react";
import AttachDocuments from "../../NovaSolicitacao/AttachDocuments.js";

import {
  Card,
  CardHeader,
  CardBody,
  ContainerButtonsRepair,
  RepairNumber,
} from "./styles.js";

import EditSolicitacaoPopup from "../../EditSolicitacaoPopup";
import { ButtonPrimary } from "../../../StyledComponent.js";
import MessagePopUp from "../../../MessagePopup/index.js";

const RepairCard = ({
  reparos,
  reparo,
  index,
  tema,
  editarSolicitacao,
  acompanharSolicitacao,
  novaSolicitacao,
  disableRemove,
  handleRemoveReparo,
  setReparos,
  // confirmarSolicitacao,
  setSalvarAlteracoes,
  savingChanges,
  isSindico,
  setShowSucessEditPopup,
  setShowSucessRemoveReparoPopup,
}) => {
  const [newDescription, setNewDescription] = useState(reparo?.description);
  const [editDescription, setEditDescription] = useState(false);
  const [showConfirmDeletePopup, setShowConfirmDeletePopup] = useState(false);

  const handleChangeDescription = () => {
    setEditDescription(false);
    let findReparo = reparos.find(
      (i) => i.idSelecaoReparo === reparo.idSelecaoReparo
    );
    let tempReparos = reparos.filter(
      (i) => i.idSelecaoReparo != reparo.idSelecaoReparo
    );

    findReparo.description = newDescription;
    tempReparos.push(findReparo);
    if (editarSolicitacao)
      setReparos(
        tempReparos.sort((a, b) =>
          a?.apontamento?.localeCompare(b?.apontamento)
        )
      );
    else
      setReparos(
        tempReparos.sort((a, b) => a?.Descricao?.localeCompare(b?.Descricao))
      );
    if (!novaSolicitacao) setSalvarAlteracoes(true);

    setShowSucessEditPopup(true);
  };

  const handleEdit = () => {
    setEditDescription((prevState) => !prevState);
    setNewDescription(reparo?.description);
  };

  const handleClickRemoveReparo = () => {
    setShowConfirmDeletePopup(false);
    setShowSucessRemoveReparoPopup(true);
    handleRemoveReparo(
      reparo?.idSelecaoReparo,
      reparo?.descricao || reparo?.Descricao || reparo?.apontamento,
      reparo?.documents
    );
  };

  return (
    <>
      <Card key={reparo.idSelecaoReparo}>
        <CardHeader className="cardHeader">
          <RepairNumber tema={tema}>
            Reparo: {(index + 1).toString().padStart(2, "0")}
          </RepairNumber>
        </CardHeader>
        <CardBody descriptionLength={reparo?.description?.length}>
          <span className="title">Apontamento:</span>
          <p className="description">
            {reparo?.descricao || reparo?.Descricao || reparo?.apontamento}
          </p>
          <span className="title">Descrição:</span>
          <div className="descriptionText">
            <p className="description">{reparo?.description}</p>
          </div>

          <AttachDocuments
            documents={reparo}
            setDocuments={setReparos}
            reparos={reparos}
            readOnly
            tema={tema}
            isSindico={isSindico}
          />

          {((acompanharSolicitacao && editarSolicitacao) ||
            novaSolicitacao) && (
            <ContainerButtonsRepair>
              <ButtonPrimary
                light
                tema={{ primaryColor: "#BE2F25" }}
                fullWidth
                disabled={disableRemove || editDescription}
                onClick={() => setShowConfirmDeletePopup(true)}
              >
                <span>Remover</span>
              </ButtonPrimary>

              <ButtonPrimary
                tema={tema}
                disabled={savingChanges}
                fullWidth
                onClick={handleEdit}
              >
                <span>Editar</span>
              </ButtonPrimary>

              {editDescription && (
                <EditSolicitacaoPopup
                  saveFn={handleChangeDescription}
                  cancelFn={handleEdit}
                  reparo={reparo}
                  setReparos={setReparos}
                  reparos={reparos}
                  newDescription={newDescription}
                  setNewDescription={setNewDescription}
                  repairNumber={index + 1}
                  tema={tema}
                  isSindico={isSindico}
                />
              )}
            </ContainerButtonsRepair>
          )}
        </CardBody>
      </Card>
      {showConfirmDeletePopup && (
        <MessagePopUp
          isError
          title={"Remover o reparo"}
          message={
            "Tem certeza de que deseja remover este reparo? Essa ação não pode ser desfeita."
          }
        >
          <ButtonPrimary
            light
            fullWidth
            tema={tema}
            onClick={() => setShowConfirmDeletePopup(false)}
          >
            Cancelar
          </ButtonPrimary>
          <ButtonPrimary
            fullWidth
            tema={{ primaryColor: "#B91C1C" }}
            onClick={handleClickRemoveReparo}
          >
            Remover
          </ButtonPrimary>
        </MessagePopUp>
      )}
    </>
  );
};

export default RepairCard;
